/**
 * StatisticsFilters Component
 *
 * Provides agent and project filtering for statistics.
 */

import { Filter } from 'lucide-react';

export default function StatisticsFilters({
  agents = [],
  projects = [],
  selectedAgentId,
  selectedProjectId,
  onAgentChange,
  onProjectChange,
}) {
  return (
    <div className="flex items-center gap-3">
      <Filter className="w-4 h-4 text-gray-500" />

      {/* Agent Filter */}
      <select
        value={selectedAgentId || ''}
        onChange={(e) => onAgentChange(e.target.value || null)}
        className="px-3 py-1.5 bg-gray-800 border border-gray-700 rounded text-sm text-white focus:outline-none focus:border-indigo-500"
      >
        <option value="">Alle Agents</option>
        {agents.map((agent) => (
          <option key={agent.id} value={agent.id}>
            {agent.displayName || agent.name}
          </option>
        ))}
      </select>

      {/* Project Filter */}
      <select
        value={selectedProjectId || ''}
        onChange={(e) => onProjectChange(e.target.value || null)}
        className="px-3 py-1.5 bg-gray-800 border border-gray-700 rounded text-sm text-white focus:outline-none focus:border-indigo-500"
      >
        <option value="">Alle Projekte</option>
        {projects.map((project) => (
          <option key={project.id} value={project.id}>
            {project.name}
          </option>
        ))}
      </select>
    </div>
  );
}
